import Questions from "../components/questions/Questions"

const SecondScreen = () => {
    return <Questions />
}

export default SecondScreen
